// eslint-disable-next-line camelcase
export const de_DE = {
	commons: {
		title: 'Mit Flightright zur Ticketerstattung',
		navigation: {
			review: 'Bereits eingegebenen Flug überprüfen',
			back: 'Zurück',
			next: 'Weiter'
		},
		sidebar: {
			navigation: 'Navigation',
			mainPageLink: 'Homepage',
			mainPageUrl: 'https://www.flightright.de',
			essentialLinks: {
				title: 'Wesentliche Links',
				privacyStatement: {
					linkText: 'Datenschutz & Cookies',
					url: 'https://www.flightright.de/datenschutz'
				},
				termsAndConditions: {
					linkText: 'AGB',
					url: 'https://www.flightright.de/agb'
				},
				imprint: {
					linkText: 'Impressum',
					url: 'https://www.flightright.de/impressum'
				}
			}
		},
		share: 'Zufrieden? Teilen Sie unseren Erstattungsservice mit Freunden und Familie',
		shareTitle: 'Flugausfall wegen Corona? Mit Flightright Geld zurück!',
		datePlaceholder: 'TT/MM/JJJJ',
		emberCCLink: 'https://www.flightright.de/entschaedigung-pruefen/#/flow/airports'
	},
	cancelled: {
		heading: 'Wer hat den Flug storniert / umgebucht?',
		airline: 'Die Airline hat meinen Flug gestrichen / umgebucht',
		customer: 'Ich habe meinen Flug storniert'
	},
	refundOffer: {
		heading: 'Hat Ihnen die Airline eine Erstattung angeboten?',
		title: 'Eine Erstattung ist eine Rückzahlung des Ticketpreises, z.B. per Überweisung. Eine Erstattung kann auch in Form eines Gutscheins oder einer Umbuchung des Fluges erfolgen. Sie müssen diese aber nicht akzeptieren und können auf eine Geldzahlung bestehen.'
	},
	refundAccepted: 'Haben Sie die Erstattung angenommen?',
	refundReceived: 'Hat die Airline Ihnen die Ticketkosten schon zurückgezahlt?',
	additionalData: {
		heading: 'Wir benötigen folgende Informationen',
		legalInsurance: 'Haben Sie eine Rechtsschutzversicherung? *',
		bookingCode: 'Buchungsnummer (Optional)',
		bookingCodePlaceholder: 'ABCDEF'
	},
	flights: {
		heading: 'Details zu Ihrer annullierten / umgebuchten Flugstrecke',
		pluralHeading: 'Ihr Flüge',
		title: 'Flug',
		returnTitle: 'Fehlenden Hinflug oder Rückflug hinzufügen',
		depAirport: 'Abflughafen',
		depAirportPlaceholder: 'Startflughafen',
		arrAirport: 'Zielflughafen',
		arrAirportPlaceholder: 'Zielflughafen',
		airline: 'Durchführende Airline',
		airlinePlaceholder: 'Airline',
		date:	'Geplantes Abflugdatum',
		datePlaceholder:	'TT/MM/JJJJ',
		timePlaceholder:	'00:00',
		departureTime: 'Abflugzeit',
		add: 'Flug hinzufügen',
		delete: 'Flug entfernen',
		additionalFlight: 'Hatten Sie einen Anschlussflug?',
		returnFlights: 'Umfasst Ihre Buchung einen Hinflug und einen Rückflug?',
		notFound: 'Ich kann meinen Flug nicht finden',
		status: {
			label: 'Flugstatus',
			placeholder: 'Bitte auswählen',
			taken: 'Ich bin geflogen / Ich werde fliegen',
			notTaken: 'Ich bin nicht mitgeflogen / Ich werde nicht fliegen',
			cancelled: 'Flug wurde gestrichen / umgebucht',
			unknown: 'Nicht bekannt, ob Flug gestrichen wurde / Flug liegt in der Zukunft'
		},
		manualScreen: {
			departureTime: 'Geplante Abflugzeit Ihres Fluges',
			sameDayToggler: {
				label: 'Sollte Ihr Flug am selben oder am nächsten Tag ankommen?s',
				sameDay: 'Am selben Tag',
				nextDay: 'Am nächsten Tag'
			},
			arrivalTime: 'Geplante Ankunftszeit Ihres Fluges',
			manualFlightNumber: 'Wie lautete Ihre Flugnummer?'
		}
	},
	uploadBox: {
		heading: 'Bitte laden Sie Ihre Buchungsbestätigung hoch',
		title: 'Bitte laden Sie Ihre alte und neue Buchungsbestätigung (enthält Flugdaten und Preise) hoch.',
		subTitle: 'Bitte leiten Sie uns zusätzlich die Benachrichtigung über die Streichung Ihrer Flüge weiter. Einfach an {serviceUrl} mit dem Betreff: “Stornierungsbenachrichtigung Fallnummer: {legalCasePublicId}"',
		serviceUrl: 'service@flightright.de',
		checkBoxText: 'Buchungsbestätigung später senden'
	},
	ticketsCost: {
		heading: 'Wie viel haben Sie für Ihre Flüge bezaht?',
		title: 'Bitte geben Sie zuerst die Gesamtsumme der ursprünglichen Flüge in Euro an.',
		ticketLabel: 'Ticketpreis für die ursprünglichen Flüge ',
		originalTicketPriceRefunded: 'Wurde Ihnen der Ticketpreis für die ursprünglichen Flüge bereits ausgezahlt?',
		alternativeTransportTaken: 'Haben Sie selbst neue Tickets für Ersatzflüge gekauft?',
		extraChargeLabel: 'Ticketpreis für die neuen Flüge',
		flightDescriptionLabel: 'Haben Sie weiterführenden Informationen zu Ihren Flügen, die Sie uns gerne mitteilen würden?'
	},
	passengers: {
		heading: 'Jetzt benötigen wir Ihre Daten',
		title: 'Bitte geben Sie Namen und E-Mail-Adresse der Person an, die die Flugtickets bezahlt hat',
		salutation: 'Anrede',
		firstNameLabel: 'Vorname',
		firstNamePlaceholder: 'z.B. Max',
		additionalFirstNamePlaceholder: 'Maxine',
		lastNameLabel: 'Nachname',
		lastNamePlaceholder: 'z.B. Mustermann',
		emailLabel: 'E-Mail-Adresse:',
		emailPlaceholder: 'z.B. you@domain.de',
		phoneLabel: 'Telefonnummer (Optional)',
		phonePlaceholder: 'z.B. 123 456 7890',
		gender: {
			male: 'Herr',
			female: 'Frau'
		},
		consentToStore: {
			text: 'Ich möchte per E-Mail über Angebote und Dienstleistungen der Flightright GmbH, der Chevalier GmbH im Bereich Arbeitsrecht und der Mobilityright GmbH im Bereich Verkehrsrecht informiert werden. Zudem bin ich damit einverstanden, Erinnerungsmails zur Vervollständigung meiner Daten zu erhalten. Meine Einwilligung kann ich jederzeit widerrufen. Für Informationen zum Datenschutz {dataProtection} klicken.',
			dataProtection: 'hier',
			urlLink: '@:(checkOut.info.privacyLink.url)',
			label: 'Ich akzeptiere'
		},
		address: {
			streetLabel: 'Straße und Hausnummer',
			streetPlaceholder: 'z.B. Windsheidstrasse 18',
			postalCodeLabel: 'Postleitzahl',
			postalCodePlaceholder: 'z.B. 12345',
			cityLabel: 'Stadt',
			cityPlaceholder: 'z.B. Berlin',
			countryLabel: 'Land',
			countryPlaceholder: 'z.B. Deutschland'
		}
	},
	checkOut: {
		heading: 'Gute Nachrichten!',
		title: 'Ihnen steht eine Erstattung in folgender Höhe zu:',
		noWinText: 'Kostenlos bei Zahlung innerhalb von 7 Tagen. Kostenpflichtig nur bei Erfolg, dann 14% Provision* plus Mwst.',
		info: {
			ticketRefundDescription: 'Wir können für Sie entweder das ursprüngliche Ticket oder die Kosten für einen alternativen Transport einfordern. Flugabschnitte, die genutzt werden, können den Auszahlungsbetrag reduzieren. Wir wählen jeweils die höchste Summe.',
			textBeforeTermsLink: 'Mit Beauftragung akzeptieren sie unsere ',
			termsLink: {
				linkText: 'AGB',
				url: 'https://www.flightright.de/agb'
			},
			textBetweenLinks: 'und nehmen die Widerrufsbedingungen sowie die ',
			privacyLink: {
				linkText: 'Datenschutzbestimmungen',
				url: 'https://www.flightright.de/datenschutz'
			},
			textAfterPrivacyLink: ' zur Kenntnis. *Wenn die Airline auf unsere außergerichtlichen Bemühungen nicht zahlt, kämpfen wir für Sie auch vor Gericht. Sollte eine Beauftragung unserer Anwälte nötig sein, fällt eine zusätzliche Gebühr in Höhe von 14% plus MwSt. an.'
		},
		btnText: 'Jetzt beauftragen (kostenpflichtig nur bei Erfolg)'
	},
	signature: {
		heading: 'Wir kämpfen für Ihr Recht',
		title: 'Für die Durchsetzung Ihrer Erstattungsforderung benötigen wir eine unterschriebene Abtretungserklärung von Ihnen.',
		checkBoxText: 'Ich möchte später unterschreiben',
		bottomText: 'Die Abtretungserklärung finden Sie auch in unserer Bestätigungs-Email. Sie können das Dokument ausdrucken, unterschreiben und an uns senden.'
	},
	summary: {
		heading: 'Wir haben Ihren Fall angelegt!',
		title: 'Danke, dass Sie Flightright beauftragt haben.',
		text: 'Sie erhalten in Kürze eine Bestätigungs-E-Mail mit Ihrer Fallnummer. Wir werden Sie künftig per E-Mail auf dem Laufenden halten und Ihnen Updates zu Ihrem Fall schicken.',
		compensation: 'Achtung: Für diesen und alte Flüge können Sie evtl. eine Entschädigung erhalten, bis zu 3 Jahre rückwirkend. Prüfen Sie Ihren Flug in unserem Entschädigungsrechner.',
		claimIdText: 'Ihre Claim ID ist ',
		newsletter: 'Melden Sie sich für einen Newsletter an',
		newsletterDescription: 'Ich möchte per E-Mail über Angebote oder Produkte der Flightright GmbH informiert werden. Meine Einwilligung kann ich jederzeit widerrufen.',
		successSignUpTitle: 'Fast geschafft...',
		successSignUpText: 'Jetzt müssen Sie nur noch den Link in der E-Mail klicken, die wir Ihnen soeben zugesendet haben. Dann ist die Anmeldung abgeschlossen.',
		primaryBtnText: 'Zum Entschädigungsrechner',
		secondaryBtnText: 'Weitere Ticketkostenerstattung einfordern',
		tertiaryBtnText: 'Anmelden'
	},
	notify: {
		heading: 'Gute Neuigkeiten',
		title: 'Gute Neuigkeiten: Sie haben Anspruch auf eine Erstattung',
		text1: `Wenn Sie Ihren Flug selbst storniert haben, ist eine Erstattung der Ticketkosten in voller Höhe leider nicht möglich. Eine rechtliche Prüfung i.S.v. § 13b Abs. 2 RDG hat nicht stattgefunden. Andere Möglichkeiten zur Durchsetzung der Forderung bleiben unberührt.
						{breakline}
						Sie können jedoch eine Erstattung der für Ihr Ticket gezahlten Steuern und Gebühren einfordern.Wir arbeiten derzeit an einem Service, der Ihnen helfen soll, diese Steuern und Gebühren von der Airline zurückzubekommen.`,
		text2: 'Sie können uns Ihre E - Mail - Adresse mitteilen, damit wir Sie kontaktieren können, wenn dieser neue Service für Sie verfügbar ist.',
		btnText: 'Jetzt weiterleiten',
		btnHref: 'https://www.flightright.de/steuern-und-gebuehren'
	},
	noClaim: {
		heading: 'Es tut uns leid! :(',
		title: 'Die Airline hat Ihnen die Ticketkosten für den ursprünglichen Flug bereits erstattet. Daher haben Sie keinen Anspruch auf eine weitere Erstattung.',
		text: `Eine rechtliche Prüfung i.S.v. § 13b Abs. 2 RDG hat nicht stattgefunden. Andere Möglichkeiten zur Durchsetzung der Forderung bleiben unberührt.
					{breakline}
					Achtung: Für diesen und alte Flüge können Sie evtl. eine Entschädigung erhalten, bis zu 3 Jahre rückwirkend. Prüfen Sie Ihren Flug in unserem Entschädigungsrechner.`,
		primaryBtnText: 'Zum Entschädigungsrechner',
		secondaryBtnText: 'Anderen Flug prüfen'
	},
	notFound: {
		heading: '@:(noClaim.heading)',
		title: 'Fehler: Seite nicht gefunden'
	},
	signaturePad: {
		linkText: 'Abtretungserklärung anzeigen',
		placeholder1: 'Klicken und zeichnen Sie Ihre Unterschrift',
		placeholder2: 'so wie sie in Ihrem Ausweis erscheint',
		retry: 'Zurücksetzen',
		use: 'Verwenden'
	},
	toggles: {
		refundOffered: {
			yes: 'Ja, mir wurde eine Erstattung angeboten',
			no: 'Nein, mir wurde keine Erstattung angeboten'
		},
		refundAccepted: {
			yes: 'Ja, ich habe sie angenommen',
			no: 'Nein, ich habe sie nicht angenommen'
		},
		refundReceived: {
			yes: 'Ja, die Airline hat mir die Ticketkosten schon zurückgezahlt',
			no: 'Nein, die Airline hat mir die Ticketkosten noch nicht zurückgezahlt'
		},
		insurance: {
			yes: 'Ja',
			no: 'Nein'
		},
		dayPeriods: {
			morning: 'Vormittags (0:00-11:59)',
			afternoon: 'Nachmittags (12:00-17:59)',
			evening: 'Abends/Nachts (18:00-23:59)'
		},
		connectionFlight: {
			yes: 'Ja',
			no: 'Ich hatte einen Direktflug'
		},
		returnFlight: {
			yes: 'Hin- und Rückflug sind Teil der Buchung',
			no: 'Nur Hinflug'
		},
		ticketsCost: {
			yes: 'Ja',
			no: 'Nein'
		}
	},
	tooltips: {
		clearAll: 'Alles entfernen',
		removeUploaded: 'Hochgeladene Dateien entfernen',
		uploadYourFiles: 'Laden Sie Ihre Dateien hoch',
		pickFiles: 'Dateien auswählen',
		uploadFiles: 'Dateien hochladen',
		abortUpload: 'Upload abbrechen'
	},
	infoBox: {
		returnFlightText: 'Für die Bearbeitung müssen wir wissen, ob Ihr Rückflug zusammen mit dem Hinflug gebucht wurde, selbst falls Sie einen Flug angetreten haben.',
		connectionFlightText: 'Hatten Sie einen Rückflug? Bitte klicken Sie auf “Ich hatte einen Direktflug” und geben Sie die Daten Ihres Rückfluges auf der nächsten Seite ein. War eine Weiterreise zu einem anderen Flughafen geplant? Dann klicken Sie auf “Ja”.'
	},
	errors: {
		fields: {
			required: 'Diese Angabe wird benötigt.',
			noResult: 'Keine Ergebnisse',
			postalCode: 'Bitte geben Sie eine gültige Postleitzahl ein',
			phoneNumber: 'Bitte geben Sie eine gültige Telefonnummer ein',
			email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
			properCityNeeded: 'Bitte geben Sie den richtigen Städtenamen an.',
			properNameNeeded: 'Bitte geben Sie einen gültigen Namen an.',
			receivedAmount: {
				equalsZero: 'Der Wert muss größer als 0 sein.',
				startsFromZero: 'Der Wert darf nicht mit 0 beginnen.'
			},
			airportMissmatch: 'Ungültiger flughafen',
			date: {
				invalid: 'Ungültiges format',
				missmatch: 'Ungültiges Flugdatum. Bitte überprüfen Sie die zuvor eingegebenen Flugdaten.'
			},
			timeIsInvalid: 'Ungültiges zeitformat',
			outOfChronology: 'Ungültige Zeitangabe. Bitte Abflugs- bzw. Ankunftszeit prüfen.',
			timeRangeIsTooLow: 'Flugzeit zu kurz. Bitte Abflugs- bzw. Ankunftszeit prüfen.',
			timeRangeIsTooBig: 'Flugzeit zu lang. Bitte Abflugs- bzw. Ankunftszeit prüfen.'
		},
		boxes: {
			signatureTooSmall: 'Bitte unterzeichnen Sie größer. Achten Sie auch darauf, dass die Unterschrift der in Ihrem Ausweis gleicht.',
			noFlightsFound: {
				text: 'Leider können wir diesen Flug im System nicht finden. Bitte prüfen Sie, ob die Angaben korrekt sind oder geben Sie die ',
				linkText: 'Flugzeit manuell ein.'
			},
			noCancelledFlightYet: {
				text: 'Der Flug ist ungültig. Bitte prüfen ',
				linkText: 'Sie Ihre Eingabe.'
			},
			newsletter: 'Abonnementfehler: Kunde kann keinen Newsletter abonnieren',
			routeDataNotSet: 'Es tut uns leid! Bei der Übermittlung dieser Informationen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
			routeDataNotUpdated: 'Es tut uns leid! Beim Aktualisieren dieser Informationen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
			ticketPriceNotSet: 'Es tut uns leid! Es ist ein Fehler beim Speichern Ihres Ticketpreises aufgetreten. Bitte versuchen Sie es erneut.',
			caseNotCreated: 'Es tut uns leid! Bei der Verarbeitung Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
			customerDataNotSet: 'Es tut uns leid! Beim Speichern Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
			flightsNotSet: 'Es tut uns leid! Beim Speichern Ihrer Flugdaten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
			flightsNotFetched: 'Es tut uns leid! Bei der Suche nach den Flügen für diese Strecke ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'
		}
	},
	partner: {
		logosBlock: {
			title: 'Nächsten Flug absichern',
			description: 'Dein langersehnter Urlaub droht ins Wasser zu fallen? Mit Flightright FirstClass hat das ein Ende!'
		},
		actionBlock: {
			title: 'Schneller umgebucht als die Airline Sorry sagen kann!',
			list: {
				1: 'Kostenloser Alternativflug bis zu 1000€ pro Person',
				2: '24 Stunden für dich erreichbar, egal welche Airline',
				3: 'Viele Extras wie Lounge Zugang inklusive'
			},
			btnLabel: 'Jetzt Absichern und garantiert Fliegen',
			btnUrl: 'https://www.flightright.de/firstclass'
		}
	}
}
